import React from "react";
import styled from "styled-components";
import {
  UserOutlined,
  CheckOutlined,
  WarningOutlined,
  CloseSquareOutlined,
  InfoCircleOutlined,
  PauseCircleOutlined,
  CheckCircleOutlined,
  WifiOutlined,
} from "@ant-design/icons";
import { Button, Tag, Tabs, Input, Radio } from "antd";
const { Search } = Input;
const FlexDiv = styled.div`
  display: flex;
  row-gap: 10px;
  align-items: center;
  border: 1px solid lightgray;
  padding: 8px 16px;
`;

const Span1 = styled.div`
  font-size: 20px;
  font-weight: 700;
`;
const Span2 = styled.span`
  color: grey;
  font-size: 14px;
`;
const Span3 = styled.span`
  color: grey;
  font-size: 14px;
  font-weight: 700;
`;
const Span4 = styled.span`
  font-size: 14px;
  color: blue;
`;
const Span5 = styled.span`
  color: blue;
  font-weight: 700;
  font-size: 16px;
  background-color: lightcyan;
`;

const RunsWrapper = styled.div`
  padding: 100px 80px;
`;

const HeaderText = styled.div`
  font-size: 24px;
  color: black;
  font-weight: 700;
  margin-bottom: 20px;
`;

const Runs = () => {
  const items = [
    {
      key: "1",
      label: "All 334",
    },
    {
      key: "2",
      label: (
        <span>
          <WarningOutlined style={{ color: "orange" }} />
          Needs Attention 0
        </span>
      ),
    },
    {
      key: "3",
      label: (
        <span>
          <CloseSquareOutlined style={{ color: "red" }} />
          Errored 115
        </span>
      ),
    },
    {
      key: "4",
      label: (
        <span>
          <InfoCircleOutlined style={{ color: "blue" }} />
          Running 0
        </span>
      ),
    },
    {
      key: "5",
      label: (
        <span>
          <PauseCircleOutlined style={{ color: "black" }} />
          On Hold 0
        </span>
      ),
    },
    {
      key: "6",
      label: (
        <span>
          <CheckCircleOutlined style={{ color: "green" }} />
          Success 150
        </span>
      ),
    },
  ];
  return (
    <RunsWrapper>
      <HeaderText>Current Run</HeaderText>
      <FlexDiv>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            backgroundColor: "grey",
          }}
        >
          <UserOutlined style={{ color: "white", fontSize: 32, padding: 4 }} />
        </div>
        <div style={{ width: "100%" }}>
          <FlexDiv style={{ border: "none", justifyContent: "space-between" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
              <Span1>Triggered via UI</Span1>
              <Tag>CURRENT</Tag>
            </div>
            <Button style={{ backgroundColor: "green", color: "white" }}>
              <CheckOutlined /> Applied
            </Button>
          </FlexDiv>
          <FlexDiv style={{ border: "none", justifyContent: "space-between" }}>
            <div>
              <Span2>#sv-dcqC9xwjs4b5M987 | </Span2>
              <Span2 style={{ color: "red" }}>destroy run | </Span2>
              <Span3>alexey-digger </Span3>
              <Span2>triggered from Terraform 5 months ago | </Span2>
              <Span5>65f89be</Span5>
            </div>
            <div>
              <Span2>5 months ago</Span2>
            </div>
          </FlexDiv>
        </div>
      </FlexDiv>
      <Tabs items={items} />
      <div style={{ display: "flex", alignItems: "center" }}>
        <Search
          placeholder="input search text"
          style={{
            width: 400,
            marginRight: 20,
          }}
        />
        <Radio.Group>
          <Radio.Button>
            <WifiOutlined /> Status
          </Radio.Button>
          <Radio.Button>
            <WifiOutlined /> Operation
          </Radio.Button>
          <Radio.Button>
            <WifiOutlined /> Source
          </Radio.Button>
        </Radio.Group>
      </div>
      <HeaderText style={{ marginTop: 30 }}>Run List</HeaderText>
      <FlexDiv>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            backgroundColor: "grey",
          }}
        >
          <UserOutlined style={{ color: "white", fontSize: 32, padding: 4 }} />
        </div>
        <div style={{ width: "100%" }}>
          <FlexDiv style={{ border: "none", justifyContent: "space-between" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
              <Span1>Triggered via UI</Span1>
              <Tag>CURRENT</Tag>
            </div>
            <Button style={{ backgroundColor: "green", color: "white" }}>
              <CheckOutlined /> Applied
            </Button>
          </FlexDiv>
          <FlexDiv style={{ border: "none", justifyContent: "space-between" }}>
            <div>
              <Span2>#sv-dcqC9xwjs4b5M987 | </Span2>
              <Span2 style={{ color: "red" }}>destroy run | </Span2>
              <Span3>alexey-digger </Span3>
              <Span2>triggered from Terraform 5 months ago | </Span2>
              <Span5>65f89be</Span5>
            </div>
            <div>
              <Span2>5 months ago</Span2>
            </div>
          </FlexDiv>
        </div>
      </FlexDiv>
      <FlexDiv>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            backgroundColor: "grey",
          }}
        >
          <UserOutlined style={{ color: "white", fontSize: 32, padding: 4 }} />
        </div>
        <div style={{ width: "100%" }}>
          <FlexDiv style={{ border: "none", justifyContent: "space-between" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
              <Span1>Triggered via UI</Span1>
              <Tag>CURRENT</Tag>
            </div>
            <Button style={{ backgroundColor: "green", color: "white" }}>
              <CheckOutlined /> Applied
            </Button>
          </FlexDiv>
          <FlexDiv style={{ border: "none", justifyContent: "space-between" }}>
            <div>
              <Span2>#sv-dcqC9xwjs4b5M987 | </Span2>
              <Span2 style={{ color: "red" }}>destroy run | </Span2>
              <Span3>alexey-digger </Span3>
              <Span2>triggered from Terraform 5 months ago | </Span2>
              <Span5>65f89be</Span5>
            </div>
            <div>
              <Span2>5 months ago</Span2>
            </div>
          </FlexDiv>
        </div>
      </FlexDiv>
      <FlexDiv>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            backgroundColor: "grey",
          }}
        >
          <UserOutlined style={{ color: "white", fontSize: 32, padding: 4 }} />
        </div>
        <div style={{ width: "100%" }}>
          <FlexDiv style={{ border: "none", justifyContent: "space-between" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
              <Span1>Triggered via UI</Span1>
              <Tag>CURRENT</Tag>
            </div>
            <Button style={{ backgroundColor: "green", color: "white" }}>
              <CheckOutlined /> Applied
            </Button>
          </FlexDiv>
          <FlexDiv style={{ border: "none", justifyContent: "space-between" }}>
            <div>
              <Span2>#sv-dcqC9xwjs4b5M987 | </Span2>
              <Span2 style={{ color: "red" }}>destroy run | </Span2>
              <Span3>alexey-digger </Span3>
              <Span2>triggered from Terraform 5 months ago | </Span2>
              <Span5>65f89be</Span5>
            </div>
            <div>
              <Span2>5 months ago</Span2>
            </div>
          </FlexDiv>
        </div>
      </FlexDiv>
    </RunsWrapper>
  );
};

export default Runs;
